import type { TGridFilters } from '~features/gridFilters';

export const FILTER_MIN_AGE = 18;
export const FILTER_MAX_AGE = 65;

export const AllDesiresId = -1;

export const emptyGridFilters: TGridFilters = {
	desire: AllDesiresId.toString(),
	minAge: FILTER_MIN_AGE,
	maxAge: FILTER_MAX_AGE,
	keyword: '',
	gender: null,
	createdBy: null,
};

export const defaultGridFilters: TGridFilters = {
	...emptyGridFilters,
	gender: 'female',
	createdBy: 'eva',
};

export const alwaysVisibleFilters: (keyof TGridFilters)[] = ['desire'];
